import { createSelector } from 'reselect';
import { IAppState } from '../../../../../AppModulesWrapper';
import { selectActivePackage } from './selectActivePackage';

export const selectActivePackageId = createSelector(
  (state: IAppState) => selectActivePackage(state),
  activePackage => activePackage?.id ?? null,
);
